import { exportActions } from '../../services';

export const exportDispatcher = dispatch => ( {
  getAvailableTypes: () => dispatch( { type: exportActions.GET } ),
  exportType: ( type, data ) => dispatch( { type: exportActions.EXPORT, exportType: type, data } ),
  customExport: ( type, data, template, fileName, metaData ) => dispatch( { type: exportActions.CUSTOMEXPORT, exportType: type, data, template, metaData, fileName } ),
  selectType: type => dispatch( { type: exportActions.SELECT, exportType: type } )
} );
